import React from "react";
import "./Button.css";

export default function Button({ children, variant = "default", ...rest }) {
  const cls = ["btn"];
  if (variant === "primary") cls.push("btn-primary");
  if (variant === "outline") cls.push("btn-outline");

  return (
    <button className={cls.join(" ")} {...rest}>
      {children}
    </button>
  );
}